import BookDemoButton from "./BookDemoButton";

// Hero section — full-bleed typographic slab (Monolith direction).
// Tagline stays as a smaller secondary line under the H1; primary CTA is demo-only.
export default function Hero() {
  return (
    <section className="v3-container v3-hero">
      <h1 className="v3-hero-h1 v3-hero-h1--sentence">Never miss another booking</h1>
      <p className="v3-hero-tagline">
        <strong>Answer. Book. Brief.</strong>
      </p>

      <div className="v3-hero-foot">
        <div className="v3-hero-foot-col">
          <span className="l">Statement</span>
          <p>
            Dash answers your business phone, books the job on your real
            calendar, and emails you who / what / when.
          </p>
        </div>
        <div className="v3-hero-foot-col">
          <span className="l">Promise</span>
          <p>
            You will not miss the booking. You will not do the paperwork. You
            will not talk to an AI that sounds like an AI.
          </p>
        </div>
        <div className="v3-hero-foot-col">
          <span className="l">Commence</span>
          <div className="v3-ctas">
            <BookDemoButton />
          </div>
          <p className="v3-hero-soft">
            Plans from $49/mo, we&apos;ll match you on the demo.
          </p>
        </div>
      </div>
    </section>
  );
}
